import React, { Fragment, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Table from './Table';
import ToggledRow from './ToggledRow';
import { useMediaQuery } from 'react-responsive/src';
import Title from './table/Title';
import TableCellText from './TableCellText';

export default function OrganizationDemandList(props) {
  let { organizationDemandsList, title, count, currentPage, onPageChange } = props;

  let [showCols, setShowCols] = useState({
    name_of_organization: true,
    name_of_user: false,
    translated_status: false,
    more: true,
  });

  let [columns, setColumns] = useState([]);

  let allColumns = [
    {
      Header: 'نام سازمان',
      accessor: 'name_of_organization',
      colName: 'name_of_organization',
      disableFilters: true,
      Cell: ({ row }) => <TableCellText text={<p>{row.original.name}</p>} />,
    },
    {
      Header: 'نام و نام خانوادگی',
      accessor: 'name_of_user',
      colName: 'name_of_user',
      disableFilters: true,
      Cell: ({ row }) => <TableCellText text={`${row.original.user.first_name} ${row.original.user.last_name}`} />,
    },
    {
      Header: 'وضعیت درخواست',
      accessor: 'translated_status',
      colName: 'translated_status',
      disableFilters: true,
      Cell: ({ row }) => <TableCellText text={row.original.translated_status} />,
    },
    {
      Header: '',
      accessor: 'more',
      colName: 'more',
      disableFilters: true,
      Cell: ({ row }) => (
        <div {...row.getToggleRowExpandedProps()}>
          <TableCellText text={<span className={'font-weight-bold'}>بیشتر...</span>} />
        </div>
      ),
    },
  ];

  let isMDScreen = useMediaQuery({ query: '(min-width: 768px)' });
  let isXLScreen = useMediaQuery({ query: '(min-width: 1200px)' });

  // Toggled row to parents (used in mobile and tablet version)
  function toggledRow(row, visibleCols) {
    let fullRowValues = {
      ...row.original,
      name_of_user: `${row.original.user.first_name} ${row.original.user.last_name}`,
    };
    let items = {
      ...(!visibleCols.name_of_organization && { name: 'نام سازمان' }),
      ...(!visibleCols.name_of_user && { name_of_user: 'نام و نام خانوادگی' }),
      ...(!visibleCols.translated_status && { translated_status: 'وضعیت درخواست' }),
    };
    return (
      <Fragment>
        <ToggledRow rowValues={fullRowValues} items={items} />
      </Fragment>
    );
  }

  function fetchData() {}

  // toggle show property in toggleCols state
  function handleToggleCols(objShowCols, showCols, hideCols = []) {
    let newObjShowCols = { ...objShowCols };
    Object.keys(objShowCols).forEach(item => {
      if (showCols.includes(item)) newObjShowCols = { ...newObjShowCols, [item]: true };
      if (hideCols.includes(item)) newObjShowCols = { ...newObjShowCols, [item]: false };
    });

    return newObjShowCols;
  }

  useEffect(() => {
    let newToggleCols = { ...showCols };

    // toggle cols => more, group_name, phone_number
    let xsShowCols = ['more'];
    let xsHideCols = ['name_of_user', 'translated_status'];

    let mdShowCols = ['translated_status', 'more'];
    let mdHideCols = ['name_of_user'];

    let xlShowCols = ['name_of_user', 'translated_status'];
    let xlHideCols = ['more'];

    if (isXLScreen && isMDScreen) newToggleCols = handleToggleCols(newToggleCols, xlShowCols, xlHideCols);
    else if (!isXLScreen && isMDScreen) newToggleCols = handleToggleCols(newToggleCols, mdShowCols, mdHideCols);
    else newToggleCols = handleToggleCols(newToggleCols, xsShowCols, xsHideCols);

    setShowCols(newToggleCols);
    /* eslint-disable-next-line */
  }, [isMDScreen, isXLScreen]);

  useEffect(() => {
    let newColumns = allColumns.filter(item => showCols[item.colName]);

    setColumns(newColumns);
    /* eslint-disable-next-line */
  }, [showCols]);

  return (
    <Fragment>
      <Title value={title} />
      <Table
        data={organizationDemandsList.data}
        /* eslint-disable-next-line */
        columns={useMemo(() => columns)}
        hasPagination={false}
        fetchData={fetchData}
        loading={organizationDemandsList.isLoading}
        count={count}
        toggledRow={toggledRow}
        showToggledRow={!isXLScreen}
        toggledRowProps={showCols}
        currentPage={currentPage}
        onPageChange={onPageChange}
      />
    </Fragment>
  );
}

OrganizationDemandList.propTypes = {
  organizationDemandsList: PropTypes.shape({
    data: PropTypes.array,
    isLoading: PropTypes.bool,
  }).isRequired,
  count: PropTypes.number,
  currentPage: PropTypes.number,
  onPageChange: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};
